@if (uiMode == 'inline') {
    <cr-customer-interaction-inline-component
            [objectIdentifier]="objectIdentifier"
            [importObjectContext]="importObjectContext"
    ></cr-customer-interaction-inline-component>
} @else {
    @if (initialized) {
<!--DONE-->
<!--        <p-tabView [(activeIndex)]="activeIndex" (onChange)="handleActiveIndex()">-->
<!--            <p-tabPanel header="Allgemein">-->
<!--                @if (basicWidgetData && activeIndex == 0) {-->
<!--                    <mvs-widget [widgetData]="basicWidgetData"></mvs-widget>-->
<!--                }-->
<!--            </p-tabPanel>-->

<!--            <p-tabPanel header="Anfrageformular">-->
<!--                @if (activeIndex == 1) {-->
<!--                    <mvs-widget *ngIf="customerFormWidget" [widgetData]="customerFormWidget"></mvs-widget>-->
<!--                }-->
<!--            </p-tabPanel>-->

<!--            <p-tabPanel header="Anhänge">-->
<!--                @if (customerInteractionDocumentDto && customerInteractionDocumentDto.length > 0 && activeIndex == 2) {-->
<!--                    <div class="flex flex-wrap gap-3 align-items-center">-->
<!--                        @for (document of customerInteractionDocumentDto; track document.id) {-->
<!--                            <div class="card pt-2 shadow-1 mb-2">-->
<!--                                <div class=" flex justify-content-between gap-2 align-items-center pb-1 mb-2 border-bottom-1 border-300">-->
<!--                                    <span class="ellipses w-10rem">{{ document.name }}</span>-->
<!--                                    <p-button (click)="openDocumentInNewWindow(document)"-->
<!--                                              styleClass="p-button-text w-1rem h-1rem"-->
<!--                                              icon="fa-regular fa-arrow-up-right-from-square"></p-button>-->
<!--                                    <p-button *ngIf="document.blob"-->
<!--                                              styleClass="p-button-text w-1rem h-1rem"-->
<!--                                              icon="fa-regular fa-download"-->
<!--                                              (onClick)="downloadBlob(document.blob, document.name || 'download.pdf')"-->
<!--                                              pTooltip="Download"-->
<!--                                              tooltipPosition="top"-->
<!--                                              aria-label="Download">-->
<!--                                    </p-button>-->
<!--                                </div>-->
<!--                                <mvs-pdf-viewer-->

<!--                                        class="cursor h-12rem block overflow-hidden"-->
<!--                                        (click)="openDocument(document)"-->
<!--                                        [objectId]="document.documentDtoId"-->
<!--                                        [imageHeader]="false"-->
<!--                                        [documentMimeType]="document.documentDto.mimeType"-->
<!--                                        [width]="150"-->
<!--                                        [height]="150"-->
<!--                                        (onDocumentLoad)="handledDocumentLoad($event, document)"-->
<!--                                >-->
<!--                                </mvs-pdf-viewer>-->
<!--                            </div>-->

<!--                        }-->
<!--                    </div>-->


<!--                }-->

<!--            </p-tabPanel>-->

<!--        </p-tabView>-->
        <p-tabs [(value)]="activeIndex" (valueChange)="handleActiveIndex()">
            <p-tablist>
                <p-tab [value]="0">Allgemein</p-tab>
                <p-tab [value]="1">Anfrageformular</p-tab>
                <p-tab [value]="2">Anhänge</p-tab>
            </p-tablist>

            <p-tabpanels>
                <!-- 🟩 Allgemein -->
                <p-tabpanel [value]="0">
                    @if (basicWidgetData && activeIndex === 0) {
                        <mvs-widget [widgetData]="basicWidgetData"></mvs-widget>
                    }
                </p-tabpanel>

                <!-- 🟦 Anfrageformular -->
                <p-tabpanel [value]="1">
                    @if (activeIndex === 1 && customerFormWidget) {
                        <mvs-widget [widgetData]="customerFormWidget"></mvs-widget>
                    }
                </p-tabpanel>

                <!-- 🟨 Anhänge -->
                <p-tabpanel [value]="2">
                    @if (customerInteractionDocumentDto?.length && activeIndex === 2) {
                        <div class="flex flex-wrap gap-3 align-items-center">
                            @for (document of customerInteractionDocumentDto; track document.id) {
                                <div class="card pt-2 shadow-1 mb-2">
                                    <div class="flex justify-content-between gap-2 align-items-center pb-1 mb-2 border-bottom-1 border-300">
                                        <span class="ellipses w-10rem">{{ document.name }}</span>

                                        <p-button
                                                icon="fa-regular fa-arrow-up-right-from-square"
                                                styleClass="p-button-text w-1rem h-1rem"
                                                (click)="openDocumentInNewWindow(document)">
                                        </p-button>

                                        <p-button
                                                *ngIf="document['blob']"
                                                icon="fa-regular fa-download"
                                                styleClass="p-button-text w-1rem h-1rem"
                                                pTooltip="Download"
                                                tooltipPosition="top"
                                                (click)="downloadBlob(document['blob'], document.name || 'download.pdf')">
                                        </p-button>
                                    </div>

                                    <mvs-pdf-viewer
                                            class="cursor h-12rem block overflow-hidden"
                                            [objectId]="document.documentDtoId"
                                            [imageHeader]="false"
                                            [documentMimeType]="document.documentDto.mimeType"
                                            [width]="150"
                                            [height]="150"
                                            (click)="openDocument(document)"
                                            (onDocumentLoad)="handledDocumentLoad($event, document)">
                                    </mvs-pdf-viewer>
                                </div>
                            }
                        </div>
                    }
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>


    }


}